<template>
  <div>
    <div
      class="
        bg-secondary-3
        border-radius--light
        border--top
        mt-3
        rounded
        border-left--color-secondary-12
        border-top--color-secondary-12
      "
    >
      <div class="parent-padding-container">
        <validation-observer
          ref="registerVisitForm"
          novalidate
          tag="form"
          @submit.prevent="submitForm"
        >
          <div class="custom-row">
            <div class="day-width d-flex">
              <div class="calendar-icon-mt">
                <em
                  class="
                    icon-block
                    fas
                    fa-calendar-alt
                    h5
                    text-orange
                    calendar-icon
                  "
                />
              </div>
              <div v-if="isEditing" class="ml-4">
                <label class="data-title mb-0">Día:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="Día"
                  rules="required"
                >
                  <custom-input
                    id="day"
                    v-model="model.day"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                  />
                </validation-provider>
              </div>
              <div v-else class="ml-4">
                <label class="data-title mb-0">Día:</label>
                <div>
                  <span>{{ data.day }}</span>
                </div>
              </div>
            </div>

            <div
              :class="
                isEditing ? 'pl-2 custom-standard-width' : 'common-view-width'
              "
            >
              <div v-if="isEditing">
                <label class="data-title mb-0">Hora Desde:</label>
                <div class="d-flex">
                  <validation-provider
                    v-slot="{ errors }"
                    name="HourStartHour"
                    rules="required"
                  >
                    <custom-input
                      id="hourStartHour"
                      v-model="model.hourStartHour"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="evalEnterHour"
                    />
                  </validation-provider>

                  <span class="mr-2 mt-1">:</span>

                  <validation-provider
                    v-slot="{ errors }"
                    name="HourStartMinute"
                    rules="required"
                  >
                    <custom-input
                      id="hourStartMinute"
                      v-model="model.hourStartMinute"
                      class="hour-size-bigger"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>

                  <div v-if="showAmPmInput" class="is-disabled-input-style">
                    <span class="disabled-box-content">
                      {{ hourStartTimeSelected.text }}
                    </span>
                    <div class="disabled-icon-style">
                      <i class="fas fa-angle-down angle-down-style" />
                    </div>
                  </div>
                  <template v-else>
                    <validation-provider
                      v-slot="{ errors }"
                      name="hourStartTime"
                      rules="required"
                    >
                      <custom-drop-down
                        id="hourStartTime"
                        v-model="hourStartTimeSelected"
                        class="ampm-size"
                        :clearable="false"
                        custom-error-msg=""
                        :error="errors[0]"
                        fieldkey="value"
                        fieldname="text"
                        :options="timeOptions"
                        @input="onChangeHourStartTime"
                      />
                    </validation-provider>
                  </template>
                </div>
              </div>
              <div v-else>
                <label class="data-title mb-0">Hora Desde:</label>
                <div class="is-flex-column">
                  <div>{{ getStartTime }}</div>
                  <template v-if="isAssistantServiceType || isTherapyABA">
                    <div>{{ getStartTimeContinued }}</div>
                  </template>
                </div>
              </div>
            </div>

            <div
              :class="
                (isEditing ? 'custom-standard-width' : 'common-view-width',
                {
                  'col-md-1': simpleContractInfo.canEditCpt,
                  'col-md-2': !simpleContractInfo.canEditCpt,
                })
              "
            >
              <div v-if="isEditing">
                <label
                  class="data-title mb-0"
                  :class="isAssistantServiceType || isTherapyABA ? '' : 'pl-3'"
                >
                  Hora Hasta:
                </label>
                <div
                  v-if="isAssistantServiceType || isTherapyABA"
                  class="d-flex"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEndHour"
                    rules="required"
                  >
                    <custom-input
                      id="hourEndHour"
                      v-model="model.hourEndHour"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>

                  <span class="mr-2 mt-1">:</span>

                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEndMinute"
                    rules="required"
                  >
                    <custom-input
                      id="hourEndMinute"
                      v-model="model.hourEndMinute"
                      class="hour-size-bigger"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>

                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEndTime"
                    rules="required"
                  >
                    <custom-drop-down
                      id="hourEndTime"
                      v-model="hourEndTimeSelected"
                      class="ampm-size"
                      :clearable="false"
                      custom-error-msg=""
                      :error="errors[0]"
                      fieldkey="value"
                      fieldname="text"
                      :options="timeOptions"
                      @input="onChangeHourEndTime"
                    />
                  </validation-provider>
                </div>
                <div v-else>
                  <div class="pl-3 mt-1">
                    <span>{{ endTime }}</span>
                  </div>
                </div>
              </div>
              <div v-else>
                <label class="data-title mb-0">Hora Hasta:</label>
                <div class="is-flex-column">
                  <div>{{ getEndTime }}</div>

                  <template v-if="isAssistantServiceType || isTherapyABA">
                    <div>{{ getEndTimeContinued }}</div>
                  </template>
                </div>
              </div>
            </div>

            <div
              class="custom-standard-width"
              :class="{
                'col-md-2': simpleContractInfo.canEditCpt && isEditing,
              }"
            >
              <label class="data-title mb-0">Tipo de Visita:</label>
              <div class="d-flex">
                <div class="visit-type-text-width">
                  {{ data.visitTypeDescription }}
                </div>
              </div>
              <span v-if="data.compensatoryInfo">
                <label class="data-title mb-0">
                  Año académico:
                </label>
                <div class="d-flex">
                  <div class="visit-type-text-width">
                    {{ data.compensatoryInfo.academicYearDesc }}
                  </div>
                </div>
              </span>
              <span v-if="data.compensatoryInfo">
                <label class="data-title mb-0">
                  Solicitud:
                </label>
                <div class="d-flex">
                  <div class="visit-type-text-width">
                    {{ data.compensatoryInfo.requestNumber }} ({{
                      data.compensatoryInfo.requestDate
                    }})
                  </div>
                </div>
              </span>
            </div>

            <div
              class="custom-standard-width"
              :class="{
                'col-md-2': simpleContractInfo.canEditCpt,
              }"
            >
              <div v-if="isEditing">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <label class="data-title mb-0">Especialista:</label>
                  <custom-drop-down
                    id="specialist"
                    v-model="specialist"
                    class="mr-3"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="getSpecialists"
                    placeholder="Seleccione"
                    @input="onSpecialistChange"
                  />
                </validation-provider>
              </div>
              <div v-else>
                <label class="data-title mb-0">Especialista:</label>
                <div class="d-flex">
                  <span>{{ data.specialistName | capitalize }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="simpleContractInfo.canEditCpt"
              class="custom-standard-width"
              :class="{
                'col-md-2': isEditing,
                'col-md-1': !isEditing,
              }"
            >
              <div v-if="isEditing">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <label class="data-title mb-0">CPT:</label>
                  <custom-drop-down
                    id="cpt"
                    v-model="cpt"
                    class="mr-3"
                    :disabled="feeScheduleCptOptions.length <= 1"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="feeScheduleCptOptions"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-else>
                <label class="data-title mb-0">CPT:</label>
                <div class="d-flex">
                  <span>{{ data.cpt?.name | empty }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="canEditSupervisor"
              class="custom-standard-width"
              :class="{
                'col-md-2': isEditing,
                'col-md-1': !isEditing,
              }"
            >
              <div v-if="isEditing">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <label class="data-title mb-0">Supervisor:</label>
                  <custom-drop-down
                    id="supervisor"
                    v-model="supervisor"
                    class="mr-3"
                    :disabled="supervisors.length == 1"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="supervisors"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-else>
                <label class="data-title mb-0">Supervisor:</label>
                <div class="d-flex">
                  <span>{{ data.supervisor?.name | empty }}</span>
                </div>
              </div>
            </div>
            <div
              :class="
                (isEditing
                  ? 'actions-edit-width is-flex-end'
                  : 'custom-standard-width is-flex-end',
                {
                  'col-md-1': isEditing,
                })
              "
            >
              <div
                v-if="showEditAndDeleteControls(data.specialistId)"
                style="margin-top: 25px"
              >
                <action-button
                  id="delete-btn"
                  class="mr-2"
                  :i="isEditing ? 'fas fa-ban' : 'fa fa-times-circle'"
                  variant="outline-danger"
                  @click="
                    isEditing
                      ? toggleEditMode()
                      : deleteVisit(data.visitId, data.replacementOfferedFlag)
                  "
                />
                <action-button
                  v-if="isEditing"
                  id="submit-btn"
                  i="fas fa-save pl-1 mt-1"
                  variant="success"
                  @click="submitForm()"
                />
                <action-button
                  v-else
                  id="edit-btn"
                  i="fa fa-edit pl-1 mt-1"
                  variant="success"
                  @click="toggleEditMode"
                />
              </div>
            </div>
          </div>

          <div
            v-if="isEditing && (isAssistantServiceType || isTherapyABA)"
            class="second-custom-row mt-2"
          >
            <div
              class="pl-2 d-flex custom-standard-width continued-hours-offset"
            >
              <validation-provider
                v-slot="{ errors }"
                name="hourContinuedStartHour"
                :rules="isSecondHourRequired ? 'required' : null"
              >
                <custom-input
                  id="hourContinuedStartHour"
                  v-model="model.hourContinuedStartHour"
                  class="hour-size"
                  custom-error-msg=""
                  :error="errors[0]"
                  mask-type="Day"
                  type="text"
                />
              </validation-provider>

              <span class="mr-2 mt-1">:</span>

              <validation-provider
                v-slot="{ errors }"
                name="hourContinuedStartMinute"
                :rules="isSecondHourRequired ? 'required' : null"
              >
                <custom-input
                  id="hourContinuedStartMinute"
                  v-model="model.hourContinuedStartMinute"
                  class="hour-size-bigger"
                  custom-error-msg=""
                  :error="errors[0]"
                  mask-type="Day"
                  type="text"
                />
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="hourContinuedStartTime"
                :rules="isSecondHourRequired ? 'required' : null"
              >
                <custom-drop-down
                  id="hourContinuedStartTime"
                  v-model="hourContinuedStartTimeSelected"
                  class="ampm-size"
                  :class="
                    hourContinuedStartTimeSelected ? 'hide-dropdown-arrow' : ''
                  "
                  :error="errors[0]"
                  fieldkey="value"
                  fieldname="text"
                  :options="timeOptions"
                  @input="onChangeHourContinuedStartTime"
                />
              </validation-provider>
            </div>
            <div class="d-flex custom-standard-width">
              <validation-provider
                v-slot="{ errors }"
                name="hourContinuedEndHour"
                :rules="isSecondHourRequired ? 'required' : null"
              >
                <custom-input
                  id="hourContinuedEndHour"
                  v-model="model.hourContinuedEndHour"
                  class="hour-size"
                  custom-error-msg=""
                  :error="errors[0]"
                  mask-type="Day"
                  type="text"
                />
              </validation-provider>

              <span class="mr-2 mt-1">:</span>

              <validation-provider
                v-slot="{ errors }"
                name="hourContinuedEndMinute"
                :rules="isSecondHourRequired ? 'required' : null"
              >
                <custom-input
                  id="hourContinuedEndMinute"
                  v-model="model.hourContinuedEndMinute"
                  class="hour-size-bigger"
                  custom-error-msg=""
                  :error="errors[0]"
                  mask-type="Day"
                  type="text"
                />
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="hourContinuedEndTime"
                :rules="isSecondHourRequired ? 'required' : null"
              >
                <custom-drop-down
                  id="hourContinuedEndTime"
                  v-model="hourContinuedEndTimeSelected"
                  class="ampm-size"
                  :class="
                    hourContinuedEndTimeSelected ? 'hide-dropdown-arrow' : ''
                  "
                  :error="errors[0]"
                  fieldkey="value"
                  fieldname="text"
                  :options="timeOptions"
                  @input="onChangeHourContinuedEndTime"
                />
              </validation-provider>
            </div>
          </div>

          <hr class="custom-hr-style" />

          <div class="custom-row">
            <div class="required-transportation-offset transportation-width">
              <div v-if="showTransportation">
                <div class="d-flex align-items-center">
                  <div
                    class="
                      custom-control custom-checkbox
                      checkbox-top-spacing
                      mt-1
                    "
                  >
                    <check-box
                      id="chTransportation"
                      v-model="model.transportation"
                      :disabled="this.isTransportationDisabled"
                      name="chTransportation"
                      text="Requiere Transportación"
                    />
                  </div>
                </div>
              </div>
              <div v-else>
                <label class="data-title mb-0">Requiere Transportación:</label>
                <div class="d-flex">
                  <span>{{ data.includesTransportation ? 'Sí' : 'No' }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="isAbsenceVisitType"
              :class="
                isEditing
                  ? isTherapyABA
                    ? 'absence-reason-aba-edit-offset aba-absence-reason-width'
                    : 'absence-reason-edit-offset absence-reason-width'
                  : 'absence-reason-offset absence-reason-width'
              "
            >
              <div v-if="isEditing">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <label class="data-title mb-0">Justificación:</label>
                  <custom-drop-down
                    id="visitAbsenceReason"
                    v-model="visitAbsenceReason"
                    class="mr-3"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="getAbsenceReasons"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-else>
                <div v-if="data.visitAbsenceReason">
                  <label class="data-title mb-0">Justificación:</label>
                  <div class="d-flex">
                    <span>{{ getVisitReasonLabel }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                isCyberTherapyOrPresentialCurrentYearVisitType ||
                  data.repositionDate
              "
              class="custom-standard-width"
              :class="
                isEditing
                  ? 'absence-reason-edit-offset'
                  : 'absence-reason-offset'
              "
            >
              <div v-if="isEditing">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <label class="data-title mb-0">Fecha a Reponer:</label>
                  <custom-drop-down
                    id="repositionDate"
                    v-model="repositionDate"
                    class="mr-3"
                    :clearable="false"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="getVisitsValidForReposition"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
              <div v-else>
                <label class="data-title mb-0">Fecha de reposición:</label>
                <div class="d-flex">
                  <span>{{ data.repositionDate }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="isStudentExcusedAbsence || data.documentId"
              :class="
                isEditing
                  ? 'file-input-container-edit-width'
                  : 'file-input-container-width is-flex-end'
              "
            >
              <div v-if="isEditing" class="is-full-width">
                <div v-if="isStudentExcusedAbsence">
                  <label class="data-title mb-0">Certificado Médico:</label>
                  <div v-if="!isEditingDocument" class="row">
                    <div class="col-8 is-vertical-center">
                      <div class="text-wrapper">
                        {{ data.documentName }}
                      </div>
                    </div>
                    <div class="col-4 is-vertical-center is-flex-end">
                      <div>
                        <action-button
                          id="download-edit-mode-btn"
                          class="mr-2"
                          i="fas fa-file-download"
                          variant="outline-success"
                          @click="downloadDocument(data.documentId)"
                        />
                        <action-button
                          id="delete-edit-mode-btn"
                          i="fa fa-times-circle "
                          variant="outline-danger"
                          @click="isEditingDocument = !isEditingDocument"
                        />
                      </div>
                    </div>
                  </div>
                  <validation-provider
                    v-else
                    v-slot="{ errors }"
                    name="fileUpload"
                    rules="required"
                  >
                    <custom-file-input
                      id="customInptFileUploadDocumentsPdf"
                      accept=".pdf"
                      accept-terms-modal-title="Certificación"
                      accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                      accept-terms-title="Acepto los términos y responsabilidades"
                      accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                      add-text=" "
                      allow-accept-terms
                      class="file-input__extended"
                      :class="!fileSelected ? 'file-input-width' : ''"
                      :custom-error-msg="''"
                      display-style="normal"
                      :error="errors[0]"
                      :on-download="() => {}"
                      required
                      :value="fileSelected"
                      @input="onFileSelected"
                    />
                  </validation-provider>
                </div>
              </div>
              <div v-else>
                <action-button
                  id="download-btn"
                  i="fas fa-file-download pl-1 mt-1 mb-1"
                  variant="success"
                  @click="downloadDocument(data.documentId)"
                />
              </div>
            </div>
          </div>

          <div
            v-if="
              data.comment ||
                (isEditing &&
                  (isCyberTherapyOrPresentialCurrentYearVisitType ||
                    isAbsenceVisitType))
            "
            class="custom-row"
          >
            <div class="required-transportation-offset comment-width">
              <label class="data-title mb-0">Comentario:</label>
              <div v-if="isEditing">
                <custom-input
                  id="comment"
                  v-model="model.comment"
                  :count-classes="['float-right']"
                />
              </div>
              <div v-else>
                <div v-if="data.comment">
                  {{ data.comment }}
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
    <div
      v-if="validations && validations.length"
      class="visit-error-container visit-error-container-mt"
    >
      <error
        v-for="(error, errorIndex) in validations"
        :key="`validation-container-visit` + errorIndex"
        :message="error"
        variant="no-border"
      />
    </div>
    <div
      v-if="data.errorMessages && data.errorMessages.length"
      class="visit-error-container visit-error-container-mt"
    >
      <error
        v-for="(error, errorIndex) in data.errorMessages"
        :key="`validation-container-visit` + errorIndex"
        :message="error"
        variant="no-border"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import rpServiceTypes from '@/utils/constants/serviceTypes.js';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { capitalize } from '@/filters';
import objectToFormData from 'object-to-formdata';

import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import CheckBox from 'CheckBox';
import visitTypes from '@/utils/constants/rpVisitTypes.js';
import rpVisitAbsenceReasons from '@/utils/constants/rpVisitAbsenceReasons.js';
import CustomFileInput from 'CustomFileInput';
import Error from 'custom-error';
import {
  validateDayEntry,
  validateEmptyTimeEntry,
  validateContractRules,
} from '@/services/uspqrp/visitService.js';
import { getSupervisors as _getSupervisors } from '@/services/uspqrp/visit.api.js';
import specialtyTypes from '@/utils/constants/specialtyTypes';

const ESPECIALISTA_ENFERMEDAD = 'Especialista - Enfermedad';

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    ActionButton,
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    CheckBox,
    CustomFileInput,
    Error,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    requestServiceTypeId: {
      type: Number,
      default: 0,
    },
    simpleContractInfo: {
      type: Object,
      default: () => {},
    },
    contractSpecialists: {
      type: Array,
      default: () => {},
    },
    visitAbsenceReasons: {
      type: Array,
      default: () => [],
    },
    visitsValidForReposition: {
      type: Array,
      default: () => [],
    },
    selectedPeriod: {
      type: Object,
      default: () => {},
    },
    hasFinalizedPeriod: {
      type: Boolean,
      default: false,
    },
    isTherapyABA: {
      type: Boolean,
      default: () => false,
    },
    feeScheduleCptOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showAmPmInput: false,
      isEditing: false,
      model: {
        day: null,
        hourStartHour: null,
        hourStartMinute: null,
        hourEndHour: null,
        hourEndMinute: null,
        transportation: false,
        hourContinuedStartHour: null,
        hourContinuedStartMinute: null,
        hourContinuedEndHour: null,
        hourContinuedEndMinute: null,
        comment: null,
      },
      hourStartTimeSelected: null,
      hourEndTimeSelected: null,
      hourContinuedStartTimeSelected: null,
      hourContinuedEndTimeSelected: null,
      specialist: null,
      isSecondHourRequired: null,
      visitAbsenceReason: null,
      fileSelected: null,
      isEditingDocument: null,
      repositionDate: null,
      validations: [],
      isTransportationDisabled: false,
      cpt: null,
      supervisor: null,
      supervisors: [],
    };
  },
  computed: {
    canEditSupervisor() {
      return (
        this.simpleContractInfo.canEditCpt &&
        this.data?.licenses.some(
          (s) =>
            s.id == specialtyTypes.OccupationalTherapyAssistant ||
            s.id == specialtyTypes.PhysicalTherapyAssistant
        )
      );
    },
    isCybertherapyVisitType() {
      if (!this.getCurrentVisitType) return false;
      return (
        this.getCurrentVisitType === visitTypes.RegularCybertherapy ||
        this.getCurrentVisitType ===
          visitTypes.CybertherapyRepositionCurrentYear
      );
    },
    showTransportation() {
      if (
        this.data.configVisitType != null &&
        this.data.configVisitType.showTransportation != null &&
        this.data.configVisitType.showTransportation == true
      ) {
        return this.isEditing;
      }
      return false;
    },
    getVisitsValidForReposition() {
      return [
        { id: this.data.replacementVisitId, name: this.data.repositionDate },
        ...this.visitsValidForReposition,
      ];
    },
    timeOptions() {
      return [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ];
    },
    getStartTime() {
      return moment(this.data.visitTimeStart, 'hh:mm A').format('hh:mm A');
    },
    getEndTime() {
      return moment(this.data.visitTimeEnd, 'hh:mm A').format('hh:mm A');
    },
    getStartTimeContinued() {
      if (!this.data.visitTimeContinuedStart) return '';
      return moment(this.data.visitTimeContinuedStart, 'hh:mm A').format(
        'hh:mm A'
      );
    },
    getEndTimeContinued() {
      if (!this.data.visitTimeContinuedEnd) return '';
      return moment(this.data.visitTimeContinuedEnd, 'hh:mm A').format(
        'hh:mm A'
      );
    },
    isAssistantServiceType() {
      return this.requestServiceTypeId == rpServiceTypes.Assistant;
    },
    isAbsenceVisitType() {
      return this.getCurrentVisitType === visitTypes.Absence;
    },
    serviceDuration() {
      return this.simpleContractInfo.duration;
    },
    includesTransportation() {
      return this.simpleContractInfo.includesTransportation;
    },
    contractId() {
      return Number(this.$route.params?.contractId);
    },
    companyId() {
      return Number(this.$route.params?.companyId);
    },
    academicYearId() {
      return Number(this.$route.params?.academicYearId);
    },
    visitId() {
      return this.data.visitId;
    },
    startTime() {
      if (
        this.isValidStartHour({
          ...this.model,
          hourStartTime: this.hourStartTimeSelected?.value,
        })
      ) {
        return moment(
          `${this.model.hourStartHour}:${this.model.hourStartMinute} ${this.hourStartTimeSelected?.value}`,
          'hh:mm A'
        );
      }
      return '';
    },
    getVisitReasonLabel() {
      if (
        this.data.visitAbsenceReasonId ===
        rpVisitAbsenceReasons.ProveedorEnfermedad
      ) {
        return ESPECIALISTA_ENFERMEDAD;
      }
      return this.data.visitAbsenceReason;
    },
    endTime() {
      if (
        this.isValidStartHour({
          ...this.model,
          hourStartTime: this.hourStartTimeSelected?.value,
        }) &&
        this.serviceDuration &&
        !this.isAssistantServiceType &&
        !this.isTherapyABA
      ) {
        return this.startTime
          .clone()
          .add(this.serviceDuration, 'minutes')
          .format('hh:mm A');
      }

      return '';
    },
    getSpecialists() {
      if (!this.contractSpecialists) return [];
      return this.contractSpecialists.map(
        ({ specialistId, specialistName, licenses }) => {
          return {
            id: specialistId,
            name: capitalize(specialistName),
            licenses,
          };
        }
      );
    },
    getAbsenceReasons() {
      const reasons = this.visitAbsenceReasons.filter(
        (x) =>
          x.id === rpVisitAbsenceReasons.AusenciaJustificada ||
          x.id === rpVisitAbsenceReasons.ProveedorEnfermedad
      );
      const customReason = reasons.find(
        (x) => x.id === rpVisitAbsenceReasons.ProveedorEnfermedad
      );
      customReason.name = ESPECIALISTA_ENFERMEDAD;
      return reasons;
    },
    isStudentExcusedAbsence() {
      if (!this.visitAbsenceReason) return false;
      return this.visitAbsenceReason.requiresDocumentationFlag;
    },
    getCurrentVisitType() {
      return this.data.visitTypeId;
    },
    isCyberTherapyOrPresentialCurrentYearVisitType() {
      return (
        this.getCurrentVisitType ===
          visitTypes.PresentialRepositionCurrentYear ||
        this.getCurrentVisitType ===
          visitTypes.CybertherapyRepositionCurrentYear
      );
    },
  },
  methods: {
    getAmPm(valueHour) {
      let result = { time: 'am', disabled: true };
      if (valueHour == 12 || (valueHour >= 1 && valueHour <= 6)) {
        result.time = 'pm';
      } else if (valueHour >= 8 && valueHour <= 11) {
        result.time = 'am';
      } else {
        result.disabled = false;
      }
      return result;
    },
    onChangeHourStartTime(input) {
      this.hourStartTimeSelected = this.timeOptions.find(
        (x) => x.value === input?.value
      );
    },
    onChangeHourEndTime(input) {
      this.hourEndTimeSelected = this.timeOptions.find(
        (x) => x.value === input?.value
      );
    },
    onChangeHourContinuedStartTime(input) {
      this.hourContinuedStartTimeSelected = this.timeOptions.find(
        (x) => x.value === input?.value
      );
      this.model.hourContinuedStartTime = this.hourContinuedStartTimeSelected?.value;
    },
    onChangeHourContinuedEndTime(input) {
      this.hourContinuedEndTimeSelected = this.timeOptions.find(
        (x) => x.value === input?.value
      );
      //Set in model
      this.model.hourContinuedEndTime = this.hourContinuedEndTimeSelected?.value;
    },
    evalEnterHour() {
      if (
        this.model.hourStartHour &&
        !this.isAssistantServiceType &&
        !this.isTherapyABA
      ) {
        const parsedHour = parseInt(this.model.hourStartHour);
        const ampmResult = this.getAmPm(parsedHour);
        this.showAmPmInput = ampmResult.disabled;
        this.hourStartTimeSelected = this.timeOptions.find(
          (x) => x.value === ampmResult.time
        );
      }
    },
    onFileSelected(file) {
      this.fileSelected = file;
    },
    parseTime(time) {
      const timeConverted = moment(time, 'hh:mm A').format('hh:mm A');
      const [hour, minutesAndTime] = timeConverted.split(':');
      const [minutes, ampm] = minutesAndTime.split(' ');

      return { hour: Number(hour), minutes, ampm };
    },
    mapData() {
      this.model.day = this.data.day;
      this.model.transportation = this.data.includesTransportation;
      this.specialist = this.getSpecialists.find(
        (x) => x.id === this.data.specialistId
      );
      this.visitAbsenceReason = this.visitAbsenceReasons.find(
        (x) => x.id === this.data.visitAbsenceReasonId
      );
      if (this.data.replacementVisitId && this.data.repositionDate)
        this.repositionDate = {
          id: this.data.replacementVisitId,
          name: this.data.repositionDate,
        };
      this.model.comment = this.data.comment;
      this.isEditingDocument = this.data.documentId === null;

      const {
        hour: hourStartHour,
        minutes: hourStartMinute,
        ampm: hourStartTime,
      } = this.parseTime(this.data.visitTimeStart);
      const {
        hour: hourEndHour,
        minutes: hourEndMinute,
        ampm: hourEndTime,
      } = this.parseTime(this.data.visitTimeEnd);
      const hasContinuedHours =
        this.data.visitTimeContinuedStart && this.data.visitTimeContinuedEnd;

      this.model.hourStartHour = hourStartHour;
      this.model.hourStartMinute = hourStartMinute;
      this.hourStartTimeSelected = this.timeOptions.find(
        (x) => x.text === hourStartTime
      );

      this.model.hourEndHour = Number(hourEndHour);
      this.model.hourEndMinute = hourEndMinute;
      this.hourEndTimeSelected = this.timeOptions.find(
        (x) => x.text === hourEndTime
      );
      this.cpt =
        this.simpleContractInfo.canEditCpt && this.data.cpt
          ? this.feeScheduleCptOptions.find(
              (cpt) => cpt.id === this.data.cpt.id
            ) || this.cpt
          : this.feeScheduleCptOptions &&
            this.feeScheduleCptOptions.length === 1
          ? this.feeScheduleCptOptions[0]
          : this.cpt;
      this.supervisor = this.data.supervisor;

      if (hasContinuedHours) {
        const {
          hour: hourContinuedStartHour,
          minutes: hourContinuedStartMinute,
          ampm: hourContinuedStartTime,
        } = this.parseTime(this.data.visitTimeContinuedStart);
        const {
          hour: hourContinuedEndHour,
          minutes: hourContinuedEndMinute,
          ampm: hourContinuedEndTime,
        } = this.parseTime(this.data.visitTimeContinuedEnd);

        this.model.hourContinuedStartHour = hourContinuedStartHour;
        this.model.hourContinuedStartMinute = hourContinuedStartMinute;
        this.hourContinuedStartTimeSelected = this.timeOptions.find(
          (x) => x.text === hourContinuedStartTime
        );

        this.model.hourContinuedEndHour = hourContinuedEndHour;
        this.model.hourContinuedEndMinute = hourContinuedEndMinute;
        this.hourContinuedEndTimeSelected = this.timeOptions.find(
          (x) => x.text === hourContinuedEndTime
        );
        this.model.hourContinuedStartTime = this.hourContinuedStartTimeSelected?.value;
        this.model.hourContinuedEndTime = this.hourContinuedEndTimeSelected?.value;
      }
      this.evalEnterHour();
    },
    toggleEditMode() {
      if (this.data.replacementOfferedFlag) {
        this.ShowToast(
          '',
          'La visita no puede ser editada, ya que cuenta con una visita de reposición.',
          'error'
        );
        return;
      }
      if (!this.isEditing) this.mapData();
      this.isEditing = !this.isEditing;
      this.validations = [];
      this.isTransportationDisabled =
        this.simpleContractInfo.includesTransportation == false;
      this.getSupervisors();
    },
    downloadDocument(documentId) {
      this.$emit('on-download-document', documentId);
    },
    async deleteVisit(id, replacementOfferedFlag) {
      this.$emit('delete-visit', { id, replacementOfferedFlag });
    },

    // validation methods
    isValidStartHour(item) {
      const _values = this.getEntryValues(item);

      if (!_values.hour || !_values.min || !_values.ampm) {
        return false;
      }

      const visitHour = moment(
        `${_values.hour}:${_values.min} ${_values.ampm}`.toUpperCase(),
        'hh:mm A',
        true
      );

      return visitHour.isValid();
    },
    getEntryValues(item) {
      return {
        hour: item.hourStartHour,
        min: item.hourStartMinute,
        ampm: item.hourStartTime,
      };
    },
    validateVisitEntry(item) {
      let validations = [];
      validations.push(
        validateEmptyTimeEntry(item, this.simpleContractInfo.contractSchedule)
      );
      validations.push(
        validateDayEntry(
          item,
          this.selectedPeriod.monthNumber,
          this.selectedPeriod.year
        )
      );
      validations.push(
        validateContractRules(
          null,
          this.simpleContractInfo.contractStartDate !== undefined
        )
      );
      validations = validations.flat();
      if (!this.specialist) validations.push('El especialista es requerido.');

      if (
        this.isCyberTherapyOrPresentialCurrentYearVisitType &&
        !this.repositionDate
      )
        validations.push('La fecha de reposición es requerida.');
      return validations;
    },

    async submitForm() {
      const isFormValid = await this.$refs.registerVisitForm.validate();

      let visitTimeEnd = this.endTime;
      let visitTimeContinuedStart = null;
      let visitTimeContinuedEnd = null;
      let replacementVisitId = null;

      this.model.hourStartTime = this.hourStartTimeSelected?.text;

      if (visitTimeEnd && !this.isAssistantServiceType && !this.isTherapyABA) {
        const {
          hour: hourEndHour,
          minutes: hourEndMinute,
          ampm: hourEndTime,
        } = this.parseTime(visitTimeEnd);

        this.model.hourEndHour = hourEndHour;
        this.model.hourEndMinute = hourEndMinute;
        this.model.hourEndTime = hourEndTime;
      }

      this.validations = this.validateVisitEntry(this.model);

      if (!isFormValid || this.validations.length) {
        return;
      }

      let visitDate = moment([
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        this.model.day,
      ])
        .format()
        .slice(0, -6);

      const visitTimeStart = moment(
        `${this.model.hourStartHour}:${this.model.hourStartMinute} ${this.hourStartTimeSelected?.text}`,
        'hh:mm A'
      ).format('hh:mm A');

      if (this.isAssistantServiceType || this.isTherapyABA) {
        visitTimeEnd = moment(
          `${this.model.hourEndHour}:${this.model.hourEndMinute} ${this.hourEndTimeSelected?.text}`,
          'hh:mm A'
        ).format('hh:mm A');
      }

      if (this.isAssistantServiceType || this.isTherapyABA) {
        if (
          this.model.hourContinuedStartHour &&
          this.model.hourContinuedStartMinute &&
          this.hourContinuedStartTimeSelected
        ) {
          visitTimeContinuedStart = moment(
            `${this.model.hourContinuedStartHour}:${this.model.hourContinuedStartMinute} ${this.hourContinuedStartTimeSelected.text}`,
            'hh:mm A'
          ).format('hh:mm A');
        }

        if (
          this.model.hourContinuedEndHour &&
          this.model.hourContinuedEndMinute &&
          this.hourContinuedEndTimeSelected
        ) {
          visitTimeContinuedEnd = moment(
            `${this.model.hourContinuedEndHour}:${this.model.hourContinuedEndMinute} ${this.hourContinuedEndTimeSelected.value}`,
            'hh:mm A'
          ).format('hh:mm A');
        }
      }

      if (this.isCyberTherapyOrPresentialCurrentYearVisitType) {
        replacementVisitId = this.repositionDate.id;
      }

      const payload = objectToFormData(
        {
          visitId: this.visitId,
          specialistId: this.specialist.id,
          contractId: this.contractId,
          visitDate,
          visitTimeStart,
          visitTimeEnd,
          visitTimeContinuedStart,
          visitTimeContinuedEnd,
          academicYearId: this.academicYearId,
          monthNumber: this.selectedPeriod.monthNumber,
          companyId: this.companyId,
          visitSummaryId: null,
          visitIsCompensatory: false,
          isCyberTherapy: null,
          requestServiceTypeId: this.isAssistantServiceType
            ? Number(rpServiceTypes.Assistant)
            : Number(rpServiceTypes.Therapy),
          visitTypeId: this.getCurrentVisitType,
          includesTransportationCost: this.model.transportation,
          replacementVisitId,
          comment: this.model?.comment,
          visitAbsenceReasonId: this.visitAbsenceReason
            ? this.visitAbsenceReason.id
            : null,
          document: this.fileSelected,
          documentId: this.isStudentExcusedAbsence
            ? this.data?.documentId
            : null,
          isTherapyABA: this.isTherapyABA,
          cptId: this.cpt?.id ?? null,
          supervisorId: this.supervisor?.id ?? null,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      this.$emit('on-update', {
        payload,
        validationPayload: {
          visitDate,
          visitTimeStart,
          visitTimeEnd,
          visitTimeContinuedStart,
          visitTimeContinuedEnd,
          visitId: this.visitId,
          isTherapyABA: this.isTherapyABA,
        },
      });
    },
    cleanModel() {
      (this.showAmPmInput = false),
        (this.isEditing = false),
        (this.model = {
          day: null,
          hourStartHour: null,
          hourStartMinute: null,
          hourEndHour: null,
          hourEndMinute: null,
          transportation: false,
          hourContinuedStartHour: null,
          hourContinuedStartMinute: null,
          hourContinuedEndHour: null,
          hourContinuedEndMinute: null,
          comment: null,
        }),
        (this.hourStartTimeSelected = null),
        (this.hourEndTimeSelected = null),
        (this.hourContinuedStartTimeSelected = null),
        (this.hourContinuedEndTimeSelected = null),
        (this.specialist = null),
        (this.isSecondHourRequired = null),
        (this.visitAbsenceReason = null),
        (this.fileSelected = null),
        (this.isEditingDocument = null),
        (this.repositionDate = null),
        (this.validations = []),
        this.$refs.registerVisitForm.reset();
    },
    cancelEditMode() {
      this.isEditing = false;
    },
    showEditAndDeleteControls(specialistId) {
      const exits = this.contractSpecialists.some(
        (specialist) => specialist.specialistId === specialistId
      );
      return exits;
    },
    onSpecialistChange(event) {
      if (event == null) {
        this.supervisors = [];
        this.specialist = null;
        this.model.supervisor = null;
      } else {
        this.getSupervisors();
      }
    },
    async getSupervisors() {
      if (!this.specialist) {
        this.supervisors = [];
        return;
      }
      const { data } = await _getSupervisors(this.specialist?.id);
      this.supervisors = data;
      if (this.supervisors.length === 1 && !this.model?.supervisor) {
        this.model.supervisor = this.supervisors[0];
      }
    },
  },
  watch: {
    visitAbsenceReason: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!value || !value.requiresDocumentationFlag) {
          this.fileSelected = null;
        }
      },
    },
    isCybertherapyVisitType: {
      immediate: true,
      handler(value) {
        if (value) this.model.transportation = false;
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import '../../../../scss/brand_variables';

.custom-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 68px;
}

.second-custom-row {
  @extend .custom-row;
  min-height: 40px;
}

.day-width {
  width: 13%;
}

.large-width {
  width: 38%;
}

.extra-large-width {
  width: 57%;
}

.custom-standard-width {
  width: 19%;
}

.transportation-width {
  @extend .custom-standard-width;
}

.common-view-width {
  width: 15%;
}

.actions-edit-width {
  width: 11%;
}

.file-input-container-edit-width {
  display: flex;
  width: 29.6%;
}

.file-input-container-width {
  display: flex;
  width: 35.3%;
}

.file-input-width {
  width: 68px;
}

.continued-hours-offset {
  margin-left: 13%;
}

.absence-reason-width {
  width: 37%;
}

.aba-absence-reason-width {
  width: 38%;
}

.absence-reason-offset {
  margin-left: 3.3%;
}

.required-transportation-offset {
  margin-left: 5.4%;
}

.comment-width {
  width: 94.6%;
}

.absence-reason-edit-offset {
  margin-left: 9%;
}

.absence-reason-aba-edit-offset {
  margin-left: 8%;
}

.offset-lg {
  margin-left: 43%;
}

//

.disabled-box-content {
  margin-bottom: 5px;
}

.disabled-icon-style {
  margin-bottom: 6px;
  margin-left: 12px;
  margin-right: -6px;
}

.angle-down-style {
  font-size: 24px;
  margin-top: 8px;
  font-weight: 510 !important;
  color: $gray-500 !important;
}

.hour-size {
  width: 50px;
  margin-right: 7px;
}

.hour-size-bigger {
  width: 50px;
  margin-right: 10px;
}

.end-hour-pd-left {
  padding-left: 15px;
}

.ampm-size {
  width: 80px;
}

.select-custom-height ::v-deep .v-select,
.select-custom-height ::v-deep .v-select > div {
  height: 38px;
}

.ampm-size ::v-deep .v-select,
.ampm-size ::v-deep .v-select > div {
  height: 38px;
  width: 68px !important;
}

.hide-dropdown-arrow ::v-deep .vs__actions > svg {
  display: none;
}

.align-items-center > .custom-control {
  padding-left: 0px !important;
}

.is-disabled-input-style {
  width: 68px;
  height: 39px;
  border: 1px solid $gray-250;
  background-color: $gray-200;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#submit-btn {
  padding-left: 5px;
  padding-right: 1px;
  padding-top: 3px;
  padding-bottom: 4px;
}

#edit-btn {
  @extend #submit-btn;
}

#delete-btn {
  @extend #submit-btn;
  padding-right: 10px;
  padding-left: 10px;
}

span > .file-input__extended ::v-deep .circle-green {
  display: none !important;
}

#delete-btn ::v-deep i {
  margin-right: 0px !important;
}

#download-edit-mode-btn ::v-deep i {
  margin-right: 0px !important;
  padding-top: 3px;
  padding-bottom: 4px;
}

#delete-edit-mode-btn ::v-deep i {
  margin-right: 0px !important;
}

#delete-edit-mode-btn {
  padding-left: 9px;
  padding-right: 9px;
}

.parent-padding-container {
  padding: 15px 20px 10px 20px;
}

.is-full-width {
  width: 100%;
}

.custom-hr-style {
  @extend .is-full-width;
}

.is-flex-end {
  display: flex;
  justify-content: flex-end;
}

.is-vertical-flex-end {
  display: flex;
  align-items: flex-end;
}

.is-vertical-center {
  display: flex;
  align-items: center;
}

.calendar-icon {
  margin-bottom: 0px;
  padding: 5px;
  border: 5px solid white;
  background-color: white;
  border-radius: 30px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.ml-6 {
  margin-left: 4rem;
}

.calendar-icon-mt {
  margin-top: 10px;
}

.is-flex-column {
  display: flex;
  flex-direction: column;
}

#download-btn {
  padding-left: 5px;
  padding-right: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.visit-type-text-width {
  width: 80%;
}

.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

.visit-error-container-mt {
  margin-top: 0.01rem !important;
}

@media (min-width: 1600px) {
  .required-transportation-offset {
    margin-left: 4%;
  }

  .comment-width {
    width: 96%;
  }

  .transportation-width {
    width: 20.4%;
  }
}
</style>
